import { useEffect, useRef } from 'react';
import { identifyUserInPostHog } from '../utils/posthogInit';
 
/**
* Custom hook to identify users in PostHog when authenticated
* Automatically resets identification on logout
*/
export const usePostHogIdentification = (user, isAuthenticated) => {
  const previousUserIdRef = useRef(null);
 
  useEffect(() => {
    // Only proceed if PostHog is initialized
    if (!window.posthog || !window.posthog.identify) {
      return;
    }

    if (isAuthenticated && user) {
      const userEmail = user.email || user.oemPartner?.email || user.user?.email;
      const userId =
        user.oemPartner?.id ||
        user.oemPartner?._id ||
        user._id ||
        user.id ||
        user.user?.id ||
        user.user?._id ||
        userEmail;
 
      if (userEmail && previousUserIdRef.current !== userEmail) {
        identifyUserInPostHog(userEmail, userId, {
          company: user.oemPartner?.companyName || user.companyName,
          role: user.oemPartner?.role || user.role,
          scanType: user.oemPartner?.scanType || user.scanType,
        });
        previousUserIdRef.current = userEmail;
      }
    } else if (!isAuthenticated && previousUserIdRef.current) {
      if (window.posthog?.reset) {
        window.posthog.reset();
      }
      previousUserIdRef.current = null;
    }
  }, [isAuthenticated, user]);
};
 
export default usePostHogIdentification;
